import { hasPermission } from './permissionsChecks'

export const Security = {
  get canViewAgents() {
    return hasPermission('agents.view.list')
  },
  get canViewQueues() {
    return hasPermission('queues.view.list')
  },
  get canViewDepartments() {
    return hasPermission('departments.view.list')
  },
  get canViewAreas() {
    return hasPermission('areas.view.list')
  },
  get canViewSpecialisations() {
    return hasPermission('specialisations.view.list')
  },
  get canViewAgentAttendance() {
    return hasPermission('analytics.view.agents.attendance.details.list')
  },
  get canViewQueueHealth() {
    return hasPermission('analytics.view.queues.details.list')
  },
  get canViewAgentTickets() {
    return hasPermission('analytics.view.agent_tickets.list')
  },
  get canViewAgentsShortAttendance() {
    return hasPermission('analytics.create.agents.attendance.short')
  },
  get canViewAdditionalFilters() {
    return hasPermission('analytics.view.tickets.queue_stats_filter.list')
  },
  get canViewIncidents() {
    return hasPermission('alerting.view.policies.list')
  },
  get canAcknowledgeIncidents() {
    return hasPermission('alerting.update.incidents.acknowledge')
  },
  get canResolveIncidents() {
    return hasPermission('alerting.update.incidents.close')
  },
  get canCompleteIncidentAction() {
    return hasPermission('alerting.update.incidents.action.complete')
  },
  get canSkipIncidentAction() {
    return hasPermission('alerting.update.incidents.action.skip')
  },
  get canViewPolicies() {
    return (
      hasPermission('alerting.view.policies.list') ||
      hasPermission('alerting.create.policies')
    )
  },
  get canCreatePolicy() {
    return hasPermission('alerting.create.policies')
  },
  get canDeletePolicy() {
    return hasPermission('alerting.delete.policies')
  },
  get canRefreshSlackUserGroups() {
    return hasPermission('alerting.create.slack.user_groups.refresh')
  },
  get canViewIncidentActions() {
    return hasPermission('alerting.view.actions.list')
  },
} as const
